<template>
  <Modal
    class="tw-translate-y-[-50%] role-add-user-modal"
    :max-width="DEFAULT_MAX_WIDTH_MODAL"
    :visible="showRef"
    @close="handleCloseModal"
  >
    <ModalHeader
      class="modal-header"
      :title="
        getComponentUiText(
          'app-settings-team-roles-manage-role-add-user-modal-title-1',
        )
      "
      @close="handleCloseModal"
    />
    <BaseForm :show="showRef" :enter-event="true" @on:submit="handleAddUser">
      <div class="tw-px-10 tw-py-[40px] modal-add-user">
        <div
          class="tw-flex tw-items-start tw-flex-col tw-gap-[15px] headingWrapper tw-pb-[40px]"
        >
          <span
            class="tw-text-[#211F58] tw-text-[22px] tw-not-italic tw-font-semibold tw-leading-[100%]"
            >{{
              getComponentUiText(
                "app-settings-team-roles-manage-role-add-user-modal-sub-title-1",
                false,
                {
                  roleName: props.roleName,
                },
              )
            }}</span
          >
          <span
            class="tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]"
            >{{
              getComponentUiText(
                "app-settings-team-roles-manage-role-add-user-modal-sub-des-1",
              )
            }}</span
          >
        </div>
        <div>
          <!-- Field : Organisation -->
          <div
            class="sm-display-column-container tw-flex tw-justify-between tw-items-center tw-my-[20px]"
          >
            <span
              class="field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
              >{{
                getUiText(
                  "app-component-custom-b-dropdown-label-organisation-1",
                )
              }}
              <span class="tw-text-[#F7553C]">*</span></span
            >
            <div
              class="field-content-container tw-flex tw-max-w-[520px] tw-w-[520px]"
            >
              <div class="dropdown-container tw-flex-1 dropdown">
                <CustomBDropDown
                  :id="'dropdownIcon'"
                  :type="'single'"
                  :data="formModel.organisation"
                  :validation="vueValidate?.organisation"
                  :class-name="'gray-dropdown-container tw-h-[58px]'"
                  :placeholder="
                    getUiText(
                      'app-component-custom-b-dropdown-prompt-organisation-1',
                    )
                  "
                  @update:move-selection-down="moveSelectionDown"
                  @update:show-drop="handleDrop"
                  @update:enter-value="handlEnter"
                  @update:move-selection-up="moveSelectionUp"
                >
                  <CustomBDropDownItem
                    v-for="(company, index) in organisationOptions"
                    :key="company.id"
                    :data="company"
                    :class-name="`normal-dropdown-container ${
                      activeItem === index ? 'activeItem' : ''
                    }`"
                    @click="handleSelectOrganisation(company)"
                  />
                </CustomBDropDown>
              </div>
            </div>
          </div>
          <!-- Field : Users -->
          <div
            class="sm-display-column-container tw-flex tw-justify-between tw-items-center tw-my-[20px]"
          >
            <span
              class="field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
              data-cy="add-user-to-role-modal-select-user-title"
              >{{
                getUiText("app-component-custom-b-dropdown-label-select-user-1")
              }}
              <span class="tw-text-[#F7553C]">*</span></span
            >
            <div
              class="field-content-container tw-flex tw-max-w-[520px] tw-w-[520px]"
            >
              <div class="dropdown-container tw-flex-1 dropdown">
                <CustomMultiSelectSearch
                  v-model="formModel.users"
                  :options="userSelects"
                  data-cy-id="add-user-to-role-modal-select-user"
                  track-by="name"
                  label="name"
                  :placeholder="`${getUiText(
                    'app-settings-team-roles-add-role-modal-form-prompt-select-users-1',
                  )}`"
                  :show-check-box="true"
                  :validation="vueValidate?.users"
                  @update:model-value="handleInputUser($event)"
                  @close:modal="
                    needCheckValidSelectUsers = true;
                    handleInputUser($event);
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="button-container tw-flex tw-flex-col tw-items-end tw-mt-[20px]"
        >
          <div class="tw-flex tw-mb-[40px] tw-gap-[10px]">
            <span
              class="tw-text-[13px] tw-text-[#B7B7B7] tw-font-medium tw-leading-[28px]"
              >{{
                getUiText(
                  "app-settings-team-roles-add-role-modal-form-button-add-user-description-1",
                )
              }}</span
            >
            <IconButton class="tw-bg-[#DBDBDB]" src="/img/plus_icon.svg" />
          </div>
          <b-button
            type="submit"
            data-cy="add-user-to-role-modal-add-user-button"
            variant="primary"
            class="button-verify tw-bg-[#387DFF] tw-h-[39px] tw-py-0 tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
          >
            <LottieAnimation
              v-if="isSubmit"
              :class="'tw-h-[41px] tw-w-full'"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />
            <span>{{
              getUiText("app-settings-team-roles-add-user-button-1")
            }}</span>
          </b-button>
        </div>
      </div>
    </BaseForm>
  </Modal>
</template>

<script setup lang="ts">
import store from "../../../store";
import utilities, { getComponentUiText } from "../../../utils/utilities";
import { Ref, computed, onMounted, reactive, ref, watch } from "vue";

import Modal from "../../common/modal.vue";
import ModalHeader from "../../common/modalHeader.vue";
import CustomBDropDown from "../../common/customBDropDown.vue";
import CustomBDropDownItem from "../../common/customBDropDownItem.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import IconButton from "@/components/common/iconButton.vue";
import CustomMultiSelectSearch from "@/components/common/customMultiSelectSearch.vue";
import { getOrgMembersAddable, posthRoleMembers } from "@/services/org";

import BaseForm from "@/components/common/form/baseForm.vue";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import ProgressAnimation from "@/assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";

const DEFAULT_MAX_WIDTH_MODAL = 45;

const grantedOrgsList: Ref<any> = computed(
  () => store.getters["Org/getGrantedOrgs"],
);

const organisationOptions: Ref | IDropDownData[] = ref([]);

const userSelectsCurrentOrg: Ref<any> = computed(
  () => store.getters["Org/getAddableOrgs"],
);

const userSelects: Ref<IDropDownData[]> = ref([]);

const currentOrg = computed(() => store.state.Org.currentOrg);

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  roleId: {
    type: String,
    required: true,
  },
  roleName: {
    type: String,
    required: true,
  },
});

// Form modal and validation.
let formModel = reactive({
  organisation: [] as IDropDownData[],
  users: [] as IDropDownData[],
});

const rules = {
  organisation: {
    required: helpers.withMessage(
      () => getUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  users: {
    required: helpers.withMessage(
      () =>
        getUiText(
          "app-settings-team-roles-add-role-modal-form-error-required-users-1",
        ),
      required,
    ),
  },
};

const emit = defineEmits(["update:show", "add:userToRole"]);
const cssFieldTitle =
  "tw-border tw-text-[#231F20] tw-text-[13px] tw-leading-none tw-px-[20px] tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#EFF0F180] tw-max-w-[520px]";
const formModalOrigin = Object.assign({}, formModel);

let vueValidate;
let showRef = ref(props.show);
let needCheckValidSelectUsers = ref(false);
let customClassInputInvalidRoleTitle = ref(cssFieldTitle);

let isGetUsers = false;
onMounted(() => {
  if (grantedOrgsList.value) setOrgList();
  if (currentOrg.value.id) {
    setAddableOrgs(currentOrg.value.id);
    isGetUsers = true;
  }
}),
  watch(
    () => props.show,
    (value) => {
      showRef.value = value;
      if (value) vueValidate = useVuelidate(rules, formModel);
      onSelectOrgDefault();
    },
  );

const setAddableOrgs = async (orgId: any) => {
  isGetUsers = false;
  try {
    await store.dispatch("Org/fetchAddableOrgList", orgId);
  } catch (error) {
    // Error
  }
};

watch(
  () => userSelectsCurrentOrg.value,
  () => {
    userSelects.value = userSelectsCurrentOrg.value.map((org) => {
      return {
        ...org,
        selected: false,
      };
    });
  },
  { deep: true },
);

const onSelectOrgDefault = () => {
  if (!organisationOptions.value || !organisationOptions.value.length) return;
  const indexOrg = organisationOptions.value.findIndex((org) => {
    return org.id === currentOrg.value.id;
  });
  const indexSelectedOrg = indexOrg > -1 ? indexOrg : 0;
  formModel.organisation = [organisationOptions.value[indexSelectedOrg]];
  userSelects.value = userSelectsCurrentOrg.value.map((org) => {
    return {
      ...org,
      name: org.name,
    };
  });
};

watch(
  () => grantedOrgsList.value,
  () => {
    setOrgList();
  },
  { deep: true },
);

const updateCurrentOrgToList = () => {
  if (!organisationOptions.value.length) pushToList();
  const indexOrg = organisationOptions.value.findIndex((org) => {
    return org.id === currentOrg.value.id;
  });
  if (indexOrg === -1) pushToList();
};

const pushToList = () => {
  if (!currentOrg.value.id) return;
  organisationOptions.value.push({
    id: currentOrg.value.id,
    name: currentOrg.value.nameShort,
    selected: false,
  });
  onSelectOrgDefault();
};
const setOrgList = () => {
  organisationOptions.value = grantedOrgsList.value.map((org) => {
    return {
      ...org,
      id: org.id,
      name: org.name,
      selected: false,
    };
  });
  updateCurrentOrgToList();
};
watch(
  () => currentOrg.value,
  () => {
    if (currentOrg.value.id && !isGetUsers) setAddableOrgs(currentOrg.value.id);
    updateCurrentOrgToList();
  },
  { deep: true },
);

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const handleSelectOrganisation = (item: IDropDownData) => {
  formModel.organisation = [item];
  vueValidate.value.organisation.$touch();
  vueValidate.value.organisation.$model = formModel.organisation;
  getUserOfOrg(item.id);
};
const activeItem = ref(0);
const handleDrop = () => {
  activeItem.value = 0;
};
const moveSelectionDown = (step) => {
  if (organisationOptions.value.length - 1 == activeItem.value) {
    activeItem.value = organisationOptions.value.length - 1;
  } else if (activeItem.value < organisationOptions.value.length) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop += 61;
    }
  }
};
const moveSelectionUp = (step) => {
  if (activeItem.value >= 1) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop -= 61;
    }
  }
};
const handlEnter = () => {
  const handleData = organisationOptions.value[activeItem.value];
  handleSelectOrganisation(handleData);
};

const getUserOfOrg = async (orgId: any) => {
  try {
    const responseData = await getOrgMembersAddable(orgId);
    if (responseData.data?.data?.length) {
      userSelects.value = responseData.data.data.map((org: any) => {
        return {
          ...org,
          id: org.userId,
          name: `${org.firstName} ${org.lastName}`,
        };
      });
    }
  } catch (error: any) {
    organisationOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getAddableOrgMembers);
    }
  }
};

const handleInputUser = (value) => {
  if (needCheckValidSelectUsers.value === false) return;

  formModel.users = value;
  vueValidate.value.users.$touch();
  vueValidate.value.users.$model = formModel.users;
};

const isSubmit = ref(false);

const handleAddUser = async () => {
  if (isSubmit.value) return;
  isSubmit.value = true;

  await vueValidate.value.$validate();
  if (vueValidate.value.$invalid) {
    isSubmit.value = false;
    return;
  }

  try {
    const payload = {
      members: formModel.users.map((user) => user.id),
    };

    await posthRoleMembers(props.roleId, payload);

    const data = {
      users: formModel.users.map((user) => {
        return {
          ...user,
          homeOrgNameShort: formModel.organisation[0].name,
          homeOrgId: formModel.organisation[0].id,
        };
      }),
    };

    isSubmit.value = false;

    const messageSuccess = getComponentUiText(
      "app-settings-team-roles-manage-role-add-user-modal-add-user-toast-message-1",
      false,
      { NumberUser: formModel.users.length.toString() },
    );

    onShowToast(messageSuccess, ToastVariant.SUCCESS);
    handleCloseModal();
    emit("add:userToRole", data);
  } catch (error: any) {
    isSubmit.value = false;
    if (error && error.data) {
      showErrorAPI(error, Org.getMembersOfRole);
    }
  }
};

const onShowToast = (message: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const clearData = () => {
  formModel = reactive(formModalOrigin);
  userSelects.value.forEach((item) => (item.selected = false));
  customClassInputInvalidRoleTitle.value = cssFieldTitle;
  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  needCheckValidSelectUsers.value = false;
  emit("update:show", showRef.value);
};
</script>

<style lang="scss">
.role-add-user-modal {
  .button-verify.btn.btn-primary[disabled] {
    background-color: #dbdbdb;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .copy-info-container {
    max-width: 70%;
  }

  .text-copy-container {
    width: calc(100% - 22px);
  }

  .button-delete {
    line-height: 100%;
    background-color: #f7553c;
    border-color: #f7553c;
  }

  .button-verify-later {
    line-height: 100%;
    border: 2px solid #387dff;
    background-color: #ffffff;
    color: #387dff;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }

  .status-domain {
    padding: 3px 5px;
    font-family: Poppins;
    font-size: 11px;
    font-weight: 500;
    line-height: 130%;
    border-radius: 4px;

    background: var(--ui-green-soft, #d9ede2);
    color: #01893d;
  }
}

@media (min-height: 768px) {
  .role-add-user-modal {
    .modal-main {
      overflow: visible;

      .dropdown-menu {
        max-height: 169px;
        overflow: auto;
      }
    }
  }
}

@media (max-width: 991px) {
  .role-add-user-modal {
    .copy-info-container {
      max-width: fit-content;
    }
  }
}

@media (max-width: 420px) {
  .role-add-user-modal {
    .button-container {
      flex-direction: column !important;
    }

    .sm-display-column-container {
      align-items: flex-start;
      flex-direction: column;

      .field-title-container {
        line-height: 24px;
        height: 24px;
      }

      .field-content-container {
        max-width: 100%;
      }
    }
  }
}

@media (max-width: 768px) {
  .role-add-user-modal {
    .field-content-container {
      display: grid;
      grid-template-columns: auto 48px;
      grid-template-areas:
        "input text"
        "dropdown dropdown";

      .input-container {
        grid-area: input;
      }

      .text-container {
        grid-area: text;
      }

      .dropdown-container {
        grid-area: dropdown;
      }
    }
  }
}
</style>
